/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

// Set true for app localized.
const defaultLocale = 'de';
const locales = ['de'];

// The format map provides an ability to separate locales from the format of dates.
// An important note is that messages is the language that will be sent to the backend as the language to get data
// LocaleFormat is what will be configured in react-intl for number and date formats.
// The messages (texts in the website) will be based on messages information, so if the user visits in this case "en"
// he would see number formatted in "en" (but it could be configured for de or pt).
// Each of the keys in the mapping will be sent to nextJs as the allowed locale.
// const formatMap = {
//   [defaultLocale]: {
//     messages: defaultLocale,
//     localeFormat: defaultRegion,
//   },
// };
const formatMap = {};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    TURBOPACK_BUILD: true,
    LOCALES: locales,
    DEFAULT_LOCALE: defaultLocale,
    FORMAT_MAP: formatMap,
    SITENAME: 'macherjobs.at',
    SITE_DESCRIPTION: 'Die besten Jobs für Macher in der Region. Das Jobportal für alle, die ihrer Karriere Schwung geben wollen. Alle Stellenanzeigen für Menschen mit Motivation und Umsetzungskraft.',
    FRONTENDS: {
      default: 'macherjobs',
    },
    SOCIAL_LINKS: {
      facebook: 'https://www.facebook.com/diemacher.at',
      linkedin: 'https://at.linkedin.com/company/diemacher',
      instagram: 'https://www.instagram.com/die.macher/',
    },
    PATH_TRANSLATIONS_ACTIVE: true,
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      bounds: {
        nelat: 49.0205305,
        nelng: 17.1608018,
        swlat: 46.37233579999999,
        swlng: 9.530734799999999,
      },
    },
    THEME: {
      colors: {
        primary: '#000000',
      },
    },
    FONTS: {
      OPTIMIZED: true,
    },
    LINKEDIN_OAUTH_FEATURE_ACTIVE: true,
    GOOGLE_OAUTH_FEATURE_ACTIVE: true,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: true,
    NEWSLETTER_FEATURE_ACTIVE: true,
    CMP_ID: 'eGvnmBbHRLDd3I',
    USERCENTRICS_AUTOBLOCKER: true,
    GA4_MEASUREMENT_IDS: ['G-TDMV7ENBV9'],
  },
});
